import { render, staticRenderFns } from "./TimeOfWiring.vue?vue&type=template&id=4222c9f5&scoped=true&"
import script from "./TimeOfWiring.vue?vue&type=script&lang=js&"
export * from "./TimeOfWiring.vue?vue&type=script&lang=js&"
import style0 from "./TimeOfWiring.vue?vue&type=style&index=0&id=4222c9f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4222c9f5",
  null
  
)

export default component.exports